import React from 'react';
import { TrendingUp, DollarSign, Calendar, CheckCircle } from 'lucide-react';

interface Props {
  application: Record<string, any>;
}

const STAGES = [
  { key: 'zapytanie', label: 'Zapytanie' },
  { key: 'zainteresowanie', label: 'Zainteresowanie' },
  { key: 'negocjacje', label: 'Negocjacje' },
  { key: 'umowa', label: 'Umowa' },
  { key: 'aktywny_partner', label: 'Partner' },
];

export const SponsorshipProgressWidget: React.FC<Props> = ({ application: app }) => {
  const currentStatus = app.hutnik_status || 'zapytanie';
  const currentIndex = STAGES.findIndex(s => s.key === currentStatus);
  const activeIdx = currentIndex >= 0 ? currentIndex : 0;

  return (
    <div className="bg-gradient-to-br from-lime-50 to-green-50 rounded-lg shadow p-5 border border-lime-200">
      <h3 className="font-bold text-sm flex items-center gap-2 mb-4 text-lime-800">
        <TrendingUp size={16} />
        Pipeline partnerski
      </h3>
      {/* Progress bar */}
      <div className="flex items-center gap-1 mb-4">
        {STAGES.map((stage, i) => (
          <div key={stage.key} className="flex-1 flex flex-col items-center">
            <div className={`w-full h-2 rounded-full ${i <= activeIdx ? 'bg-lime-500' : 'bg-gray-200'}`} />
            <span className={`text-[10px] mt-1 ${i <= activeIdx ? 'text-lime-700 font-medium' : 'text-gray-400'}`}>
              {stage.label}
            </span>
          </div>
        ))}
      </div>
      <div className="grid grid-cols-2 gap-3 text-sm">
        {app.partnership_tier && (
          <div className="flex items-center gap-2">
            <CheckCircle size={14} className="text-lime-500 shrink-0" />
            <span>Tier: <strong>{app.partnership_tier}</strong></span>
          </div>
        )}
        {app.contract_value && (
          <div className="flex items-center gap-2">
            <DollarSign size={14} className="text-lime-500 shrink-0" />
            <span>{Number(app.contract_value).toLocaleString('pl-PL')} zł</span>
          </div>
        )}
        {app.contract_start && (
          <div className="flex items-center gap-2">
            <Calendar size={14} className="text-lime-500 shrink-0" />
            <span>{new Date(app.contract_start).toLocaleDateString('pl-PL')} — {app.contract_end ? new Date(app.contract_end).toLocaleDateString('pl-PL') : '...'}</span>
          </div>
        )}
        {app.selected_benefits && (
          <div className="col-span-2 text-xs text-gray-600">
            Benefity: {typeof app.selected_benefits === 'string' ? app.selected_benefits : JSON.stringify(app.selected_benefits)}
          </div>
        )}
      </div>
    </div>
  );
};
